import React from 'react';
import { rst } from 'rt-state';
import { ErrorType } from '../validator';
import { useTranslation } from 'react-i18next';

const TR = rst.createS<{ name: string; options?: any }>((props) => {
    const { t } = useTranslation();
    return t(props.name, props.options);
});

export function transLabel(label: any) {
    if (typeof label === 'string') {
        return <TR name={label} />;
    }
    return label;
}

export const transError = (error: ErrorType) => {
    if (error == null) {
        return null;
    }
    let msg, options;
    if (typeof error === 'string') {
        msg = error;
    } else {
        msg = error.msg;
        options = error.options;
    }
    return <TR name={msg} options={options} />;
};
